export default __webpack_public_path__ + "assets/000e79f22fbd2a2b5bcedb155d29128c-business_card.png";